import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { CustomEncoder } from "@/shared-module/helpers/customencoder";

@Injectable({ providedIn: "root" })
export class ZoomService {
  constructor(private http: HttpClient) {}

  get(prms: any = null, selectedPeriod: number = null) {
    // without these lines, the + character is not encoded in the url,
    // see : https://github.com/angular/angular/issues/18884

    // Serialize object values to JSON strings so HttpParams doesn't reduce them to [object Object]
    const serialized: Record<string, string> = {};
    for (const key of Object.keys(prms ?? {})) {
      const val = prms[key];
      serialized[key] = val !== null && val !== undefined && typeof val === "object"
        ? JSON.stringify(val)
        : val;
    }

    let params = new HttpParams({
      fromObject: serialized,
      encoder: new CustomEncoder(),
    });

    if (selectedPeriod) {
      params = params.set("periodId", selectedPeriod.toString());
    }

    return this.http.get<string>(`api/zoom`, { params }).pipe((s) => {
      return s;
    });
  }

  getTexts() {
    return this.http.get<string>(`api/texts`).pipe((s) => {
      return s;
    });
  }
}
